import { render, staticRenderFns } from "./AppBreadcrumbs.vue?vue&type=template&id=1d8a27eb"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports